import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ac73bca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "BigLoading"
}
const _hoisted_2 = { class: "SettingsContainer" }
const _hoisted_3 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_4 = { class: "DialogSection" }
const _hoisted_5 = { class: "F-H2" }
const _hoisted_6 = {
  key: 0,
  class: "DialogSection P-Rel",
  style: {"z-index":"50"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_8 = { class: "DialogSection" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_11 = {
  key: 1,
  style: {"width":"100%"}
}
const _hoisted_12 = { class: "DialogSection" }
const _hoisted_13 = { class: "F-H1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_15 = {
  class: "DialogSection",
  style: {"display":"grid","grid-template-columns":"85%","gap":"1em","justify-items":"center"}
}
const _hoisted_16 = { style: {"display":"flex","align-items":"center","gap":"1em","justify-content":"start-flex"} }
const _hoisted_17 = {
  key: 0,
  style: {"margin":"0"}
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_21 = { class: "DialogSection" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cookiesslide = _resolveComponent("Cookiesslide")!
  const _component_CookiesLoading = _resolveComponent("CookiesLoading")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.Loading.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Cookiesslide),
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createVNode(_component_CookiesLoading)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        style: _normalizeStyle([{"background-size":"27em","opacity":"0.02","pointer-events":"none","z-index":"-5"}, 'background-image: url(' + _ctx.Pattern + ');']),
        class: "P-Abs Inset0 O-50"
      }, null, 4),
      (_ctx.Access('HR_PayrollItemTypes_Edit'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.Translate('Payroll Item Types')), 1)
            ]),
            (_ctx.TableReady)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_CookiesTable, {
                    onEditCalendar: _ctx.EditCalendar,
                    onFieldEdited: _ctx.FieldEdited,
                    onInputChanged: _ctx.InputChanged,
                    onDeleteRow: _ctx.RemoveItem,
                    class: "Shadow1",
                    TableSettings: _ctx.TableSettingsPayrollItemTypes,
                    CookiesData: _ctx.CookiesData,
                    Search: '',
                    Loading: (_ctx.Loading.length > 0),
                    Saving: (_ctx.Saving.length > 0),
                    Saved: _ctx.Saved
                  }, null, 8, ["onEditCalendar", "onFieldEdited", "onInputChanged", "onDeleteRow", "TableSettings", "CookiesData", "Loading", "Saving", "Saved"])
                ]))
              : _createCommentVNode("", true),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.NewPayrollItemType())),
                  class: "CookiesButton BGMain F-Bold"
                }, [
                  _createVNode(_component_CookiesIcon, {
                    class: "M-Auto SQR1_5em",
                    style: {"padding-inline-end":"0.5em"},
                    ID: 'Add'
                  }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.Translate('Add Payrol Item')), 1)
                ])
              ])
            ]),
            _hoisted_9,
            _hoisted_10
          ]))
        : _createCommentVNode("", true),
      (_ctx.Access('HR_Shifts_Edit'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h1", _hoisted_13, _toDisplayString(_ctx.Translate('Shifts')), 1),
              _hoisted_14
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Shifts, (Shift) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "W-100",
                  key: Shift?.ID
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    (Shift?.Name)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_17, _toDisplayString(_ctx.Translate(Shift?.Name)), 1))
                      : _createCommentVNode("", true),
                    (Shift?.Description)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.Translate(Shift?.Description)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.Access('HR_Shifts_Edit'))
                      ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                          key: 2,
                          onClick: ($event: any) => (_ctx.EditShift(Shift)),
                          class: "SQR1_5em HoverGlow Shadow2",
                          ToolTip: _ctx.Translate('Edit'),
                          ID: ('Edit' as IconsIDs)
                        }, null, 8, ["onClick", "ToolTip"]))
                      : _createCommentVNode("", true),
                    (_ctx.Access('HR_Shifts_Remove'))
                      ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                          key: 3,
                          onClick: ($event: any) => (_ctx.DeleteShift(Shift)),
                          class: "SQR1_5em HoverGlow Shadow2",
                          ToolTip: _ctx.Translate('Delete'),
                          ID: ('Delete' as IconsIDs)
                        }, null, 8, ["onClick", "ToolTip"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_CookiesTable, {
                    onEditCalendarShiftItem: _ctx.EditCalendarShiftItem,
                    onFieldEdited: _ctx.FieldEditedShiftItem,
                    onInputChanged: _ctx.InputChangedShiftItem,
                    onDeleteRow: _ctx.RemoveShiftItem,
                    class: "Shadow1",
                    TableSettings: _ctx.TableSettingsShiftItems(Shift),
                    CookiesData: Shift?.ShiftItems ? Shift.ShiftItems : [],
                    Search: ''
                  }, null, 8, ["onEditCalendarShiftItem", "onFieldEdited", "onInputChanged", "onDeleteRow", "TableSettings", "CookiesData"]),
                  _hoisted_19,
                  (_ctx.Access('HR_ShiftItems_Create'))
                    ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                        key: 0,
                        onClick: ($event: any) => (_ctx.NewShiftItem(Shift)),
                        class: "SQR2_5em HoverGlow Shadow2 M-Auto",
                        ToolTip: _ctx.Translate('Add Shift Item'),
                        ID: ('Add' as IconsIDs)
                      }, null, 8, ["onClick", "ToolTip"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.NewShift())),
                  class: "CookiesButton BGMain F-Bold"
                }, [
                  _createVNode(_component_CookiesIcon, {
                    class: "M-Auto SQR1_5em",
                    style: {"padding-inline-end":"0.5em"},
                    ID: 'Add'
                  }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.Translate('New Shift')), 1)
                ])
              ])
            ]),
            _hoisted_22,
            _hoisted_23
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}